import firebase from 'firebase/app';
import 'firebase/firestore'
import 'firebase/storage';

const firebaseConfig = {
    apiKey: "AIzaSyCDIe1Axsa9iB9_I005YkiJ6qZFvaaAqp8",
    authDomain: "npc-connect.firebaseapp.com",
    projectId: "npc-connect",
    storageBucket: "npc-connect.appspot.com",
    messagingSenderId: "220117555696",
    appId: "1:220117555696:web:323b4440d22ff2a1556535",
    measurementId: "G-Y4DPDZ28GJ"
};
//export default firebaseConfig;
const firebaseApp = firebase.initializeApp(firebaseConfig)
const firebaseStorage = firebase.storage();
const db = firebase.firestore()


// collection references
const dbProfiles = db.collection('userProfiles')

export {
    firebaseApp,
    db,
    dbProfiles,
    firebaseStorage
}